/**
 * Domain-specific error classes for Family domain
 *
 * These errors provide better context for business logic violations
 * and help with error handling in API routes and UI
 */

import { DomainError } from '@/shared/types/errors';

/**
 * Base error class for Family domain errors
 */
class FamilyDomainError extends DomainError {
  constructor(message: string) {
    super(message);
    this.name = 'FamilyDomainError';
  }
}

/**
 * Thrown when family validation rules are violated
 * Examples: duplicate family, invalid family name, etc.
 */
export class FamilyValidationError extends FamilyDomainError {
  constructor(message: string) {
    super(message);
    this.name = 'FamilyValidationError';
  }
}

/**
 * Thrown when invitation validation fails
 * Examples: expired invitation, already used, not found
 */
export class InvitationValidationError extends FamilyDomainError {
  constructor(message: string) {
    super(message);
    this.name = 'InvitationValidationError';
  }
}

/**
 * Thrown when member not found or validation fails
 * Examples: member not found, member doesn't belong to family
 */
export class MemberNotFoundError extends FamilyDomainError {
  constructor(memberId: string) {
    super(`Member not found: ${memberId}`);
    this.name = 'MemberNotFoundError';
  }
}

/**
 * Thrown when authorization check fails
 * Examples: wrong family, not owner, not adult, etc.
 */
export class AuthorizationError extends FamilyDomainError {
  constructor(message: string) {
    super(message);
    this.name = 'AuthorizationError';
  }
}

